import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useState } from 'react';
import { Dayjs } from 'dayjs';

import { CustomButton, Picker, Text } from '../shared/uiComponents';
import { TEXT } from '../shared/Helpers/colors';

import { parseWallClockTime } from '../shared/Helpers/timezones';

interface ClockInDialogProps {
	open: boolean;
	onClose: () => void;
	onConfirm: (clockInStart: Dayjs, clockInEnd: Dayjs) => void;
	loading?: boolean;
	scheduledStartTime: string;
	scheduledEndTime: string;
}

const ClockInDialog = ({ open, onClose, onConfirm, loading, scheduledStartTime, scheduledEndTime }: ClockInDialogProps) => {
	const [clockInStart, setClockInStart] = useState<Dayjs | null>(parseWallClockTime(scheduledStartTime));
	const [clockInEnd, setClockInEnd] = useState<Dayjs | null>(parseWallClockTime(scheduledEndTime));

	return (
		<Dialog
			open={open}
			onClose={onClose}
			PaperProps={{ sx: { borderRadius: '12px', padding: '8px', minWidth: '340px' } }}
		>
			<DialogTitle sx={{ fontWeight: 600, fontSize: '16px', pb: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
				Enter Actual Session Time
				<IconButton onClick={onClose} size="small" aria-label="close">
					<Close fontSize="small" />
				</IconButton>
			</DialogTitle>
			<DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: '16px', pt: '16px !important' }}>
				<div>
					<Text title="Scheduled Time" type="pxs" fontWeight="medium" color={TEXT.TERTIARY} />
					<Text
						title={`${parseWallClockTime(scheduledStartTime).format('hh:mm A')} \u2013 ${parseWallClockTime(scheduledEndTime).format('hh:mm A')}`}
						type="psm"
						fontWeight="semiBold"
					/>
				</div>
				<Picker.CustomTime label="Actual Start" value={clockInStart} onChange={setClockInStart} />
				<Picker.CustomTime label="Actual End" value={clockInEnd} onChange={setClockInEnd} />
			</DialogContent>
			<DialogActions sx={{ px: 3, pb: 2 }}>
				<CustomButton
					title="Cancel"
					buttonType="secondaryGray"
					onClick={onClose}
				/>
				<CustomButton
					title="Start Session"
					onClick={() => {
						if (clockInStart && clockInEnd) onConfirm(clockInStart, clockInEnd);
					}}
					loading={loading}
					disabled={!clockInStart || !clockInEnd}
				/>
			</DialogActions>
		</Dialog>
	);
};

export default ClockInDialog;
